import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export function useLibraryRouteSync() {
    const route = useRoute();
    const router = useRouter();

    const widgetFormOpen = computed(() => !!route.query.widgetForm && !!route.query.id);

    const setWidgetFormParams = async (dashboardId: string, widgetId: string) => {
        await router.replace({
            query: { ...route.query, widgetForm: widgetId, id: dashboardId },
        });
    };

    const closeWidgetForm = async () => {
        const query = { ...route.query };
        delete query.widgetForm;
        delete query.id;
        await router.replace({ query });
    };

    const goToDashboard = async (dashboardId: string) => {
        await router.push({
            path: 'dashboard',
            query: { id: dashboardId },
        });
    };

    return {
        widgetFormOpen,
        setWidgetFormParams,
        closeWidgetForm,
        goToDashboard,
    };
}
